import { useIntl } from 'react-intl';

import { Dropdown } from '#src/atoms/dropdowns/Dropdown/index.tsx';
import { More } from '#src/atoms/icons/More.tsx';
import { NavItem } from '#src/components/navigation/NavItem/index.tsx';
import { useIsInTraining } from '#src/hooks/commonGame/useIsInTraining.ts';
import { useIsLaptop } from '#src/hooks/device/useIsLaptop.ts';
import { navLabels } from '#src/lib/glossary.ts';

import { MoreNavItems } from '../MoreNavItems/index.tsx';
import { DropdownContent } from '../NavItemWithSubNav/index.tsx';

type Props = { sidebarCollapsed?: boolean };

export const MoreNavDropdown = ({ sidebarCollapsed }: Props) => {
  const { formatMessage } = useIntl();
  const isLaptopAndAbove = useIsLaptop();
  const isInTraining = useIsInTraining();

  if (!isLaptopAndAbove || isInTraining) {
    return null;
  }

  return (
    <Dropdown
      forceDesktopBehavior
      triggerOnHover
      side="right"
      gap={24}
      label={({ open, ...otherProps }) => (
        <menu {...otherProps} type="menu">
          <li>
            <NavItem
              icon={() => <More size={2} />}
              label={formatMessage(navLabels.more)}
              sidebarCollapsed={sidebarCollapsed}
            />
          </li>
        </menu>
      )}
    >
      {({ closeDropdown }) => (
        <DropdownContent>
          <MoreNavItems onClick={closeDropdown} />
        </DropdownContent>
      )}
    </Dropdown>
  );
};
